import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {flightStatus as flightStatusService} from 'services/flight.service'
import {formatResponse} from './flightstatus.utils'

export interface flightStatus {
    isLoading: boolean
    error: any
    initialValues: object
    response: object
    carrier: string
}

const initialState: flightStatus = {
    isLoading: false,
    error: null,
    initialValues: {
        carrier: '-Select-',
        flightDate: new Date(),
        flightNo: ''
    },
    response: [],
    carrier: ''
}

const throwError = (data) => {
    if (!data.successFlag || typeof data === 'string') {
        throw Error(String(data.errorList).match(/text=(.*?)(?=\])/)?.[1] ?? 'Something went wrong')
    }
}

export const fetchFlightStatus = createAsyncThunk('fetchFlightStatus', async (payload: any, {rejectWithValue}) => {
    let carrier = ''
    try {
        const matches = payload.carrier.match(/\((\w+)\)$/)
        if (matches && matches.length >= 2) {
            carrier = matches[1]
        }

        const flightStatusRequest = {
            carrier,
            flightDate: payload.flightDate.toISOString(),
            flightNumber: payload.flightNo,
            userId: payload.userId
        }
        const {data} = await flightStatusService(flightStatusRequest)
        const formattedData = data.response.messages ? [] : formatResponse(data.response)
        throwError(data)
        return {
            response: formattedData,
            payload,
            carrier
        }
    } catch (err: any) {
        return rejectWithValue({
            error: err.message,
            payload,
            carrier
        })
    }
})

const flightStatusSlice = createSlice({
    name: 'flightStatus',
    initialState,
    reducers: {
        resetState: (state) => initialState
    },
    extraReducers: function (builder) {
        builder.addCase(fetchFlightStatus.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchFlightStatus.fulfilled, (state, action) => {
            state.isLoading = false
            state.response = action.payload.response
            state.carrier = action.payload.carrier
            state.initialValues = action.payload.payload
            state.error = null
        })
        builder.addCase(fetchFlightStatus.rejected, (state, action: any) => {
            state.isLoading = false
            state.response = []
            state.carrier = action.payload.carrier
            state.initialValues = action.payload.payload
            state.error = action.payload.error
        })
    }
})

export const {resetState} = flightStatusSlice.actions
export const {reducer: flightStatusReducer} = flightStatusSlice
